<template lang="jade">
  div.Prompt(v-bind:class="{ 'Prompt--open': open }")
    div.Prompt__container
      div.Prompt__header
        h3.Prompt__title {{ form.title }}
      div.Prompt__body
        form.Form(skin="default"
                  v-el:form)
          dynamic-input(v-for="input in form.properties"
                        ":model.sync"="input.value"
                        ":schema"="input")
      div.Prompt__footer(skin="default")
        div.Button-group
          button.Button.Button--primary(":skin"="skins.buttons"
                                        type="button"
                                        @click="cancel") CANCEL
          button.Button.Button--primary(":skin"="skins.buttons"
                                        type="button"
                                        @click="submit") OK
</template>
<script>
  import dialogs from './_shared/traits'
  import { dynamic } from 'src/components/inputs/index'

  export default {
    data () {
      return {}
    },
    mixins: [dialogs],
    props: {
      form: {
        type: Object,
        required: true
      }
    },
    components: {
      'dynamic-input': dynamic.input
    },
    methods: {
      submit () {
        /* eslint-disable no-undef */
        let data = new FormData(this.$els.form)
        this.callback(data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// prompt.vue?db62e0ec